import { render, staticRenderFns } from "./KreirajNovo.vue?vue&type=template&id=8b552420&"
import script from "./KreirajNovo.vue?vue&type=script&lang=js&"
export * from "./KreirajNovo.vue?vue&type=script&lang=js&"
import style0 from "./KreirajNovo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports